import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArrowRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.429 12a1.5 1.5 0 0 1 1.5-1.5h10.52l-4.51-4.51a1.5 1.5 0 1 1 2.122-2.122l7.07 7.071a1.5 1.5 0 0 1 0 2.122l-7.07 7.07a1.5 1.5 0 1 1-2.122-2.12l4.51-4.511H4.93a1.5 1.5 0 0 1-1.5-1.5'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowRight)
export default ForwardRef
